<template>
  <v-btn @click="toggle" :disabled="value === undefined" icon :color="value ? 'yellow' : null">
    <v-icon>
      {{ value ? 'mdi-star' : 'mdi-star-outline' }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'PartToggleFavorite',
  props: {
    partId: {
      type: String,
      required: true
    },
    value: {
      type: Boolean
    }
  },
  methods: {
    toggle: async function() {
      try {
        const { data } = await this.$api.patch(`adminpart/${this.partId}/toggle-favorite`)

        if (!data.success) throw data.message ?? 'Something went wrong'

        this.$emit('update', data.model)
        this.$notifier.showSuccess({ message: 'Ændringen blev gemt' })
      } catch (error) {
        console.error(error)
        this.$notifier.showError({ message: 'Noget gik galt!' })
      }
    }
  }
}
</script>